import React from 'react';
import "../components/SmallLoader.css";
const SmallLoader = () => {
  return (
    <span className="small-loader"></span>
  )
}

export default SmallLoader